<lib-modal-container
  class="bootstrap-wrapper"
  classModalTitle="bg-azul-sunedu"
  [modalTitle]="'Seleccionar ubicación'"
  cancelText="Cerrar"
  [noActions]="true"
  (dismiss)="handleClose()">

  <div>
    <div>
      <label class="font-bold">Cambiar local</label>
    </div>
    <lib-form-control
      appearance="outline"
      variant="select"
      [formGroupParent]="form"
      placeholder="Seleccione"
      controlName="idLocal"
      [options]="comboLists.locales.list"
      [disabled]="comboLists.locales.loading || gridLocales.loading">
    </lib-form-control>
  </div>

  <div class="m-b-25">
    <lib-grid
      variant="list"
      class="sunedu-grid-blue"
      [loading]="gridLocales.loading"
      [definition]="gridLocales.definition"
      [source]="gridLocales.source"
      [fixedLayout]="false">
      <ng-template
        libTemplate="tpl-opciones"
        let-data>
        <mat-radio-group
          [disabled]="gridLocales.loading"
          [value]="localSeleccionado"
          name="localSeleccionado"
          (change)="handleChangeLocal($event)">
          <mat-radio-button [value]="data"></mat-radio-button>
        </mat-radio-group>
      </ng-template>
    </lib-grid>
  </div>

  <div class="text-center">
    <button
      mat-flat-button
      class="rounded-full bg-azul-sunedu"
      (click)="handleAceptar()">
      Aceptar
    </button>
  </div>

</lib-modal-container>
